import React, { useEffect, useState } from 'react';
import { FaBusinessTime, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { GoSearch } from 'react-icons/go';
import { useLocation } from 'react-router-dom';
import hero from '../Assets/AdobeStock_439136266-scaled.jpeg';
import formationImage from '../Assets/logo512.png';
import formations from '../formations';

const SearchableFormationList = () => {
	const location = useLocation();
	const [searchTerm, setSearchTerm] = useState('');
	const [expandedFormation, setExpandedFormation] = useState(null);

	// Effect to handle auto-expanding from navigation
	useEffect(() => {
		// Check if a formation ID was passed through navigation state
		const state = location.state;
		if (state && state.expandedFormationId) {
			setExpandedFormation(state.expandedFormationId);
		}
	}, [location.state]);

	// Filter formations based on the search term
	const filteredFormations = formations.filter((formation) =>
		formation.title.toLowerCase().includes(searchTerm.toLowerCase())
	);

	return (
		<div className='w-full h-auto flex flex-col items-center justify-center'>
			{/* Hero Section */}
			<div
				className='w-full md:w-[80%] p-4 lg:px-24 bg-cover bg-center min-h-[950px] h-auto shadow-lg'
				style={{
					backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 1) 30%, rgba(255, 255, 255, 0.7) 60%, rgba(255, 255, 255, 0.5) 80%), url(${hero})`
				}}
			>
				<div className='w-full h-36 flex flex-row items-center justify-center'>
					<img src={formationImage} alt='/' className='h-36' />
				</div>
				{/* Search Bar */}
				<div className='mb-6 flex items-center'>
					<div className='relative w-full'>
						<GoSearch className='absolute left-4 top-3 w-5 h-5 text-gray-400' />
						<input
							type='text'
							placeholder='Rechercher une formation...'
							className='w-full pl-12 pr-4 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-[#87152B]'
							value={searchTerm}
							onChange={(e) => setSearchTerm(e.target.value)}
						/>
					</div>
				</div>

				{/* Formation List */}
				<div className='space-y-4'>
					{filteredFormations.map((formation) => (
						<div
							key={formation.id}
							className='border border-[#AC9961] rounded-lg shadow-md overflow-hidden transition-all duration-300'
						>
							{/* Formation Header */}
							<div
								className='p-4 bg-[#87152B] text-white cursor-pointer flex justify-between items-center transition-all ease-in-out duration-300'
								onClick={() =>
									setExpandedFormation(
										expandedFormation === formation.id
											? null
											: formation.id
									)
								}
							>
								<h3 className='text-lg font-semibold'>
									{formation.title}
								</h3>
								{expandedFormation === formation.id ? (
									<FaChevronUp className='w-6 h-6 text-white' />
								) : (
									<FaChevronDown className='w-6 h-6 text-white' />
								)}
							</div>

							{/* Dropdown Content */}
							<div
								className={`transition-all duration-700 ease-in-out ${
									expandedFormation === formation.id
										? 'max-h-screen'
										: 'max-h-0'
								} overflow-hidden`}
							>
								<div className='p-4 bg-[white] text-black flex flex-col md:flex-row items-center justify-start'>
									<ul className='list-disc pl-5 w-[95%] md:w-[70%]'>
										{formation.subFormations.map(
											(subFormation, index) => (
												<li key={index}>
													{subFormation}
												</li>
											)
										)}
									</ul>
									<p className='text-base flex bg-white w-[70%] md:w-[25%] flex-row items-center justify-center mb-6 gap-6 py-2 px-4 rounded-xl shadow-xl p-4'>
										<FaBusinessTime size={30} />
										<span className='text-2xl '>
											{formation.duration} jours
										</span>
									</p>
								</div>
							</div>
						</div>
					))}
					{filteredFormations.length === 0 && (
						<p className='text-center text-gray-500'>
							Aucune formation trouvée.
						</p>
					)}
				</div>
			</div>
		</div>
	);
};

export default SearchableFormationList;
